import {
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  Row
} from "react-bootstrap";
import React, { Component } from "react";

import Button from "../../elements/CustomButton/CustomButton.jsx";
import Card from "../Card/Card";
import { FormattedMessage } from "react-intl";
import PhoneInput from "../Phone/PhoneInput";

class ContactCards extends Component {
  renderContactRow(contact, index) {
    return (
      <Col key={index} xs={12} sm={6}>
        <Card
          content={
            <FormGroup key={`${index}`}>
              {index === 0 ? (
                <div />
              ) : (
                <div className="card-delete-btn">
                  <Button
                    onClick={() => this.props.removeLine(index)}
                    chip={true}
                  >
                    <i style={{ width: "17px" }} className="fa fa-trash" />
                  </Button>
                </div>
              )}
              <ControlLabel>
                <FormattedMessage
                  id="ids_name"
                  description="contact name input field label"
                  defaultMessage="Nom"
                />
              </ControlLabel>
              <FormControl
                name="name"
                defaultValue={contact.name}
                onBlur={e =>
                  this.props.updateLineValue(index, "name", e.target.value)
                }
              />
              <ControlLabel>
                <FormattedMessage id="ids_email" />
              </ControlLabel>
              <FormControl
                name="email"
                defaultValue={contact.email}
                onBlur={e =>
                  this.props.updateLineValue(index, "email", e.target.value)
                }
              />
              <ControlLabel>
                <FormattedMessage id="ids_fixPhone" />
              </ControlLabel>
              <PhoneInput
                value={contact.telFixe}
                country={this.props.country}
                update={e =>
                  this.props.updateLineValue(index, "telFixe", e.value)
                }
              />
              <ControlLabel>
                <FormattedMessage id="ids_mobilePhone" />
              </ControlLabel>
              <PhoneInput
                value={contact.telMobile}
                country={this.props.country}
                update={e =>
                  this.props.updateLineValue(index, "telMobile", e.value)
                }
              />
              <ControlLabel>
                <FormattedMessage id="ids_function_job" />
              </ControlLabel>
              <FormControl
                name="job"
                defaultValue={contact.job}
                onBlur={e =>
                  this.props.updateLineValue(index, "job", e.target.value)
                }
              />
            </FormGroup>
          }
        />
      </Col>
    );
  }
  render() {
    return (
      <div>
        <div className="align-items-start">
          <h4>
            <FormattedMessage id="ids_contacts" />{" "}
          </h4>
          <div
            style={{ marginTop: "38px", marginLeft: "10px" }}
            onClick={() => this.props.addLine()}
          >
            <i className="fa fa-plus" />
            <FormattedMessage id="ids_add" />{" "}
          </div>
        </div>
        <Row>
          {this.props.lines.map((contact, i) => {
            return this.renderContactRow(contact, i);
          })}
        </Row>
        {/* <a onClick={() => this.props.addLine()}><i className="fa fa-plus"></i>Ajouter</a> */}
      </div>
    );
  }
}

export default ContactCards;
